let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4yUSc")).then(() => parcelRequire('9xi4O'));